import {postJSON} from 'util/Net';

export function generateLabelTemplatePreview(zplTemplate: string): JQueryPromise<{data: string}> {
  return postJSON({
    url: '/1/api/label-templates:preview',
    data: {zplTemplate},
    untracked: true,
  });
}
